import React from "react";
import DialogBox from "@techsoftware/happay-widgets/DialogBox";
import Icons from "customComponents/icons";

const titleStyle = {
    fontFamily: "Roboto-Medium",
    fontSize: "16px",
    textAlign: "left",
    color: "#ffffff"
};
const titleDivStyle = {
    borderRadius: "2px 2px 0px 0px",
    fontSize: "inherit",
    lineHeight: "inherit",
    backgroundColor: "#334969",
    padding: "10px 10px 10px 20px",
    minHeight: 50,
    display: "flex",
    alignItems: "center"
};

const CustomDialog = props => {
    const maxWidth = +props.fullWidth || +props.width > 600 ? +props.width || "100%" : 600;
    const bodyStyle1 = {
        // fontSize: "14px",
        // minHeight: "180px",
        // borderRadius: "4px !important",
        // fontFamily: "Roboto-Regular",
        // color: "#16325c",
        // padding: "10px 60px 10px 60px",
        // padding: "6px 60px 30px",
        // background: "#FFFFFF",
        maxWidth
    };
    const {
        open,
        title,
        contentStyle,
        removeCrossBtn,
        onRequestClose,
        bodyStyle,
        fromPage,
        actionsContainerStyle,
        removeCrossIcon,
        removeActionBorder
    } = props;
    // if(props.isWidgetComp){
    //       return   <DialogBox
    //             {...props}
    //             open={open}
    //             id="123"
    //             onClose={props.onRequestClose}
    //             title={title}
    //             titleBorder
    //             actionBorder
    //             crossIcon
    //             minHeight="500px"
    //             bodyStyle={{ ...bodyStyle1, ...bodyStyle }}
    //             // height="500px"
    //             // width="500px"
    //         >
    //             {props.children}
    //             </DialogBox>
    // }

    const dialogTitle = (
        <div style={titleDivStyle}>
            <span style={{ width: "100%", ...titleStyle }}>{title}</span>
            {!removeCrossBtn && (
                <Icons
                    type="cross"
                    interactive
                    className="float-right white-color dialog-close-button"
                    onClick={onRequestClose}
                />
            )}
        </div>
    );
    return (
        <DialogBox
            // eslint-disable-next-line react/jsx-props-no-spreading
            // overlayStyle={{ backgroundColor: "rgba(35, 52, 76, 0.50)" }}
            // actionsContainerStyle={{
            //     borderTop: "1px solid #eef2f7",
            //     padding: "10px 6px",
            //     ...actionsContainerStyle
            // }}
            // open={!!open}
            // title={fromPage != "fleetXpressModal" ? dialogTitle : null}
            // contentStyle={contentStyle || { maxWidth: "660px" }}
            // bodyStyle={{ ...bodyStyle1, ...bodyStyle }}
            // autoScrollBodyContent
            {...props}
            id="expense-dialogBox"
            open={open}
            // id="123"
            onClose={props.onRequestClose}
            title={title}
            // titleBorder
            actionBorder={removeActionBorder ? false : true}
            crossIcon={removeCrossIcon ? false : true}
            // minHeight="500px"
            bodyStyle={{ ...bodyStyle1, ...bodyStyle }}
            // bodyStyle={{ maxWidth }}

            dialogStyle={{ maxWidth, ...props.dialogStyle }}
            // titleClass={"dialog-titleClass"}
        />
    );
    // }
};
export default CustomDialog;
